module.exports = __webpack_public_path__ + "static/media/task2Planet2.29d01a87.png";